module.exports = __webpack_public_path__ + "img/plan_point_badge_1.143c03f2.png";